<script context="module" lang="ts">
	let response: string = '';
	export let CaptchaValid = false;
	export function AppendCaptchaData(formData: FormData) {
		console.log('appending captcha data:', response);
		formData.append('g-recaptcha-response', response || '');
	}
	export let footer_checked = false;
</script>

<script lang="ts">
	import { onMount } from 'svelte';
	import type { MouseEventHandler } from 'svelte/elements';
	import { grecaptcha, type ReCaptcha } from '$lib/captcha_types';
	import {
		PUBLIC_RECAPTCHA_SECRET,
		PUBLIC_ENVIRONMENT,
		PUBLIC_SHOW_RECAPTCHA
	} from '$env/static/public';
	import { KTIForm } from '../form';
	import Phone from './Phone.svelte';
	import type Email from './Email.svelte';
	import { Event } from '../../event';
	let ConsentTitle: string | null = null;
	let ConsentDesc: string | null = null;
	let Terms: string | null = null;
	export let phoneValid = false;
	export let phoneRequired = false;
	export let emailValid = false;
	export let emailRequired = false;

	let showCaptcha = ConsentTitle !== null ? false : true; //Show captcha immediately if no consent required
	let loaded = PUBLIC_ENVIRONMENT === 'dev' || PUBLIC_SHOW_RECAPTCHA === 'false';
	//export let recaptcha: ReCaptcha;
	async function setupGreCaptcha() {
		console.log('window.grerecaptcha', window?.grecaptcha);
		while (window.grecaptcha === undefined) {
			//waiting for grecaptcha'
			console.log('waiting for grecaptcha');
			await new Promise((r) => setTimeout(r, 1000));
		}
		window.grecaptcha.ready(() => {
			console.log('grecaptcha ready');
			window.grecaptcha.render('grecaptchaDIV', {
				sitekey: PUBLIC_RECAPTCHA_SECRET,
				theme: 'light',
				callback: (res) => {
					console.log('callback->response:', res);
					CaptchaValid = true;
					response = res;
				},
				'error-callback': () => {
					console.error('recaptcha, likely network issue');
					CaptchaValid = false;
				},
				'expired-callback': () => {
					CaptchaValid = false;
				}
			});
			loaded = true;
		});
	}
	function phoneValidityChange(data: boolean) {
		console.log('phoneValidityChange:', data);
		phoneValid = data;
		if (phoneValid) {
			ConsentTitle = newsletter_consent_title_both;
			ConsentDesc = newsletter_consent_desc_both;
		} else {
			ConsentTitle = newsletter_consent_title_email;
			ConsentDesc = newsletter_consent_desc_email;
		}
	}
	function emailValidityChange(data: boolean) {
		emailValid = data;
	}
	const newsletter_consent_title_email =
		'By checking this box, I am indicating I wish to receive email communications.';
	const newsletter_consent_desc_email =
		'You may view our Privacy Policy <a target="_blank" href="https://www.kingtechnology.com/privacy-policy/">here</a>; as well as Terms &amp; Conditions <a target="_blank" href="https://www.frogproducts.com/terms/">here</a>.';
	const newsletter_consent_title_both =
		'By checking this box, I am indicating I wish to receive communications via email and text.';
	const newsletter_consent_desc_both =
		'Text messages average 4 msg/month. Message & Data Rates may apply. You may view our Privacy Policy <a target="_blank" href="https://www.kingtechnology.com/privacy-policy/">here</a>; as well as Terms &amp; Conditions <a target="_blank" href="https://www.frogproducts.com/terms/">here</a>.';
	onMount(async () => {
		console.log('Footer mounted');
		//Look for email component in form config
		let emailComp = KTIForm.form_config.components.find((comp) => comp.Type === 'Email');
		if (emailComp) {
			//let emailSvelteComp: Email = emailComp.Comp as unknown as Email;
			emailRequired = emailComp.Required;
			Event.on('emailValidChange', emailValidityChange);
		}
		//Look for phone component in form config
		let phoneComp = KTIForm.form_config.components.find((comp) => comp.Type === 'Phone');
		if (phoneComp) {
			//let phoneSvelteComp: Phone = phoneComp.Comp as unknown as Phone;
			phoneRequired = phoneComp.Required;
			Event.on('phoneValidityChanged', phoneValidityChange);
		}
		ConsentDesc = KTIForm.form_config.ConsentDesc ?? null;
		ConsentTitle = KTIForm.form_config.ConsentTitle ?? null;
		if (KTIForm.form_config.URLName === 'newsletter_signup_consumer') {
			ConsentTitle = newsletter_consent_title_email;
			ConsentDesc = newsletter_consent_desc_email;
		}
		if (!ConsentTitle) {
			//There is not consent title, set footer_checked to true
			footer_checked = true;
		}
		Terms = KTIForm.form_config.Terms ?? '';
		if (PUBLIC_ENVIRONMENT === 'dev' || PUBLIC_SHOW_RECAPTCHA === 'false') {
			console.log('development environment, skipping captcha');
			return;
		}
		setupGreCaptcha();
		// console.log('grecaptcha:', grecaptcha);
		// console.log('recaptcha:', recaptcha);
		// recaptcha = grecaptcha;
		// grecaptcha.render('grecaptchaDIV', {
		// 	sitekey: PUBLIC_RECAPTCHA_SECRET,
		// 	theme: 'light',
		// 	callback: (res) => {
		// 		console.log('callback->response:', res);
		// 		captchaValid = true;
		// 		response = res;
		// 	},
		// 	'error-callback': () => {
		// 		console.log('recaptcha, likely network issue');
		// 		captchaValid = false;
		// 	},
		// 	'expired-callback': () => {
		// 		captchaValid = false;
		// 	}
		// });
	});
	function consentOnClick(e: MouseEvent & { currentTarget: EventTarget & HTMLInputElement }) {
		const target = e.target as HTMLInputElement; // Cast to HTMLInputElement
		if (target.checked) {
			showCaptcha = true;
		}
	}
</script>

<svelte:head>
	<script src="https://www.google.com/recaptcha/api.js"></script>
</svelte:head>
{#if ConsentTitle}
	<div class="form-group row required">
		<div class="col" id="contactConsentDiv">
			<br />
			<div class="form-check">
				<input
					class="form-check-input"
					id="contactConsentCheckBox"
					type="checkbox"
					name="contactConsentCheckBox"
					bind:checked={footer_checked}
					on:click={consentOnClick}
				/>
				<label class="form-check-label" for="contactConsentCheckBox"
					><b>{@html ConsentTitle}</b></label
				>
				<div class="invalid-tooltip" id="contactConsentError">Consent is Required</div>
			</div>
			{#if ConsentDesc}
				<p id="contactConsentText" class="snuggle" />
				<p class="small snuggle" style="padding-left:26px">
					{@html ConsentDesc}
				</p>
			{/if}
		</div>
	</div>
{/if}
<!-- <div id="asdf" class="g-recaptcha" data-sitekey="6Lc7h74hAAAAAEZhk2lDjF-iTU-DI0KFVSvUe81J"></div>
<div class="g-recaptcha" data-sitekey="6Lc7h74hAAAAAEZhk2lDjF-iTU-DI0KFVSvUe81J"></div> -->
<!-- <div class="col d-flex justify-content-center">
	<div class="form-group row required captchaRow g-recaptcha" id="recaptchaDiv" data-sitekey="6Lc7h74hAAAAAEZhk2lDjF-iTU-DI0KFVSvUe81J"></div>
  </div> -->
{#if showCaptcha}
	<span class="smallBR" />
{/if}
{#if !(PUBLIC_ENVIRONMENT == 'dev' || PUBLIC_SHOW_RECAPTCHA === 'false')}
	<div class="col d-flex justify-content-center">
		<div id="grecaptchaDIV" class:d-none={!showCaptcha} />
		<!-- <div class="form-group row required captchaRow g-recaptcha" id="recaptchaDiv" data-sitekey="6Lc7h74hAAAAAEZhk2lDjF-iTU-DI0KFVSvUe81J"></div> -->
	</div>
{/if}

<div class="form-group row">
	<div class="text-center">
		<button class="btn btn-primary" id="submitBtn" class:d-none={!loaded}>Submit</button>
	</div>
</div>

{#if Terms}
	<div class="row">
		<div class="col d-flex justify-content-center">
			<span class="small fs-7 terms">
				{@html Terms}
			</span>
		</div>
	</div>
{/if}

<style>
	.smallBR {
		height: 5px;
		margin-bottom: 50px;
	}
	.terms {
		/* if font-size = 12.8 (0.8 rem aka fs-7) */
		line-height: 15.8px;
	}
</style>
